import { Injectable, Output, EventEmitter, Input } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor() {}

  @Output() setIndex = new EventEmitter<number>();
  @Output() menuClose = new EventEmitter<void>();

}
